import { getLocale, isAppDevice } from '@pb/utils'

const mobileAppProtocol = 'hmgoe:'

export const getFullTouchpointUrl = (): any =>
  `${isAppDevice() ? mobileAppProtocol : window.location.protocol}//${
    window.location.hostname
  }/${getLocale()}`
